import React from 'react';

/**
 * Template 14: JHAROKHA Button Component
 * Primary: bg-[#0D9488] text-white
 * Secondary: border-2 border-[#0D9488] text-[#0D9488]
 */
const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    onClick,
    className = '',
    type = 'button',
    disabled = false,
}) => {
    const baseClasses = "inline-flex items-center justify-center gap-2 font-medium tracking-wide uppercase transition-all duration-300 active:scale-[0.97]";

    const variants = {
        primary: "bg-[#0D9488] text-white hover:bg-[#0F766E]",
        secondary: "border-2 border-[#0D9488] text-[#0D9488] hover:bg-[#0D9488] hover:text-white bg-transparent",
        outline: "border border-[#E5E7EB] text-[#1A1A1A] hover:border-[#0D9488] hover:text-[#0D9488] bg-transparent",
        ghost: "text-[#0D9488] hover:bg-[#F0FDFA] bg-transparent",
    };

    const sizes = {
        sm: "px-4 py-2 text-xs",
        md: "px-6 py-3 text-sm",
        lg: "px-8 py-3.5 text-sm",
        xl: "px-10 py-4 text-base",
    };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
            style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 600 }}
        >
            {children}
        </button>
    );
};

export default Button;
